import { Link } from 'react-router';

import { PermissionGate } from '@/auth/PermissionGate';
import { Cargando, Encabezado, ErrorCarga, Vacio } from '@/components/Estados';

import { useManuales } from './queries';

function Lista() {
  const q = useManuales();
  return (
    <>
      <Encabezado
        titulo="Manuales"
        descripcion="Catálogo fijo de manuales. Los «advance» se habilitan por permisos de la licencia; aquí se editan sus páginas."
      />
      {q.isPending && <Cargando />}
      {q.isError && <ErrorCarga error={q.error} onReintentar={() => void q.refetch()} />}
      {q.data?.length === 0 && <Vacio titulo="No hay manuales" />}
      {q.data && q.data.length > 0 && (
        <div className="panel-vidrio overflow-x-auto p-0">
          <table className="tabla-cs w-full text-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>Manual</th>
                <th>Edición</th>
                <th>Páginas</th>
              </tr>
            </thead>
            <tbody>
              {q.data.map((m) => (
                <tr key={m.id}>
                  <td className="tabular">{m.id}</td>
                  <td>
                    <Link
                      to={`/contenido/manuales/${m.id}`}
                      className="font-semibold hover:underline"
                    >
                      {m.name}
                    </Link>
                  </td>
                  <td>{m.edition === 'advance' ? 'Advance' : 'Básico'}</td>
                  <td className="tabular">{m.pagesCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

export function ManualesPage() {
  return (
    <PermissionGate seccion="contenido">
      <Lista />
    </PermissionGate>
  );
}
